import React from 'react'
import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Divider, Button, Form, Col, Row } from '_zari/core'

import { TiposDocumentoSunatConstant, CodigosTransaccionesConstant } from 'constants/index'
import ModalidadGuiasVentas from 'constants/tiposModalidadGuiaVenta'

import { DateHandler } from 'utils'

import * as FormGroups from './formGroups'
import * as Sections from './sections'
import ValidationSchema from './validation'

import SerieNumeroFormGroup from 'sharedComponents/inputs/text/generarNumeroDocumento'
import { RetrocederButton } from 'sharedComponents/buttons'

import * as TransferenciaService from 'services/transferencia.service'
import { AdminContext } from 'contexts/AdminContext'

const actualizarFila = (current, { cantidad, ...restPayload }) => {
  current = {
    ...current,
    ...restPayload,
    cantidad
  }
  return current
}

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      let newState = state
        .map(val => ({
          ...val,
          __filaActiva: false,
          __focusCantidad: false,
          __focusDescuento: false,
          __focusPrecio: false,
          esFilaBusqueda: false
        }))
        .filter(x => x._idProductoPresentacion)

      let { viaCodBar, _id, ...payload } = action.payload
      return [
        ...newState,
        {
          ...payload,
          __filaActiva: !viaCodBar,
          __focusCantidad: !viaCodBar,
          _idProductoPresentacion: _id,
          _idFila: Math.round(new Date() / 1000),
          cantidad: '1'
        },
        {
          __filaActiva: viaCodBar,
          esFilaBusqueda: true,
          _idFila: `${Math.round(new Date() / 1000)}-G`
        }
      ]
    }
    case 'actualizar': {
      const { aplicarTodos, saltarFila, ...nuevoPayload } = action.payload
      return state.map(val => {
        if (val.esFilaBusqueda) {
          val.__filaActiva = saltarFila
        } else {
          if (val._idFila === nuevoPayload._idFila) {
            val = actualizarFila(val, nuevoPayload)
          }
          val.__filaActiva = !saltarFila
        }
        return val
      })
    }
    case 'actualizarComentario':
      return state.map((val, i) => {
        if (val._idFila === action.payload._idFila) {
          val.comentario = action.payload.comentario
        }
        return val
      })
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const NuevoMainForm = ({ queryParams, history }) => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const [detalles, detallesDispatcher] = React.useReducer(commonReducer, [
    {
      esFilaBusqueda: true,
      _idFila: Math.round(new Date() / 1000)
    }
  ])

  const formInitialValues = React.useMemo(() => {
    const nuevaFecha = DateHandler.format(new Date())

    return {
      _idConductor: '',
      _idPlaca: '',
      _idSedeDestino: '',
      _idTransportista: '',
      codigoMotivo: '',
      comentario: '',
      fechaEmision: nuevaFecha,
      fechaEntrega: '',
      fechaTraslado: '',
      modalidad: '',
      numeroDocumento: '',
      serieDocumento: '',
      tipoDocumento: ''
    }
  }, [])


  const submitHandler = (data, { setSubmitting }) => {
    const arrFecha = data.fechaEmision.split('/')
    if (arrFecha[1] !== __adminContext.mesTrabajo) {
      __zariContext.snack('error', 'La fecha seleccionada debe estar en el mes de trabajo')
      setSubmitting(false)
      return
    }
    const detallesNormalizados = detalles
      .map(x => ({
        _idProductoPresentacion: x._idProductoPresentacion,
        cantidad: parseFloat(x.cantidad),
        comentario: x.comentario
      }))
      .filter(x => x._idProductoPresentacion)

    TransferenciaService.nuevaTransferencia({
      ...data,
      detalles: detallesNormalizados
    })
      .then(() => {
        __zariContext.snack('success', 'La transferencia se ha generado.')
        history.push(`/${CodigosTransaccionesConstant.TRANSFERENCIAS_SALIDA_LISTA}${queryParams}`)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Row>
      <Col md={12}>
        <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
          {({
            errors,
            handleSubmit,
            isSubmitting,
            touched,
            values,
            handleChange,
            setValues,
            handleBlur,
            setFieldValue
          }) => (
            <>
              <Form>
                <Row>
                  <Col md={4}>
                    <FormGroups.FechaEmisionFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.fechaEmision}
                      iTouched={touched.fechaEmision} />
                    <FormGroups.SedeDestinoFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors._idSedeDestino}
                      iTouched={touched._idSedeDestino}
                    />
                    <FormGroups.TipoDocumentoFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.tipoDocumento}
                      iTouched={touched.tipoDocumento}
                      handleChange={handleChange}
                      values={values}
                      setValues={setValues}
                    />
                    <FormGroups.SerieDocumentoFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.serieDocumento}
                      iTouched={touched.serieDocumento}
                      vTipoDocumento={values.tipoDocumento}
                    />
                    <SerieNumeroFormGroup
                      // fIsSubmitting={isSubmitting}
                      // iError={errors.numeroDocumento}
                      // iTouched={touched.numeroDocumento}
                      fIsSubmitting={isSubmitting}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      vSerie={values.serieDocumento}
                      vTipoDocumento={values.tipoDocumento}
                      vTipoOperacion='11'
                      iTouched={touched.numeroDocumento}
                      iError={errors.numeroDocumento}
                    />
                  </Col>
                  {values.tipoDocumento === TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE && (
                    <>
                      <Col md={4}>
                        <FormGroups.MotivoFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.codigoMotivo}
                          iTouched={touched.codigoMotivo}
                        />
                        <FormGroups.FechaEntregaFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.fechaEntrega}
                          iTouched={touched.fechaEntrega}
                        />
                        <FormGroups.FechaTrasladoFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.fechaTraslado}
                          iTouched={touched.fechaTraslado}
                        />
                      </Col>
                      <Col md={4}>
                        <FormGroups.ModalidadFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.modalidad}
                          iTouched={touched.modalidad}
                          handleChange={handleChange}
                          values={values}
                          setValues={setValues}
                        />
                        {values.modalidad === ModalidadGuiasVentas.PRIVADO && (
                          <>
                            <FormGroups.ConductorFormGroup
                              fIsSubmitting={isSubmitting}
                              iError={errors._idConductor}
                              iTouched={touched._idConductor}
                            />
                            <FormGroups.PlacaFormGroup
                              fIsSubmitting={isSubmitting}
                              iError={errors._idPlaca}
                              iTouched={touched._idPlaca}
                            />
                          </>
                        )}
                        {values.modalidad === ModalidadGuiasVentas.PUBLICO && (
                          <>
                            <FormGroups.TransportistaFormGroup
                              iError={errors._idTransportista}
                              iTouched={touched._idTransportista}
                              fIsSubmitting={isSubmitting}
                            />
                          </>
                        )}
                      </Col>
                    </>
                  )}
                </Row>
                <Divider />
                <Sections.DetallesSection detalles={detalles} dispatch={detallesDispatcher} />
                <Divider />
                <Row className='mt-2'>
                  <Col md={6}>
                    <FormGroups.ComentarioFormGroup
                      iError={errors.comentario}
                      iTouched={touched.comentario}
                      fIsSubmitting={isSubmitting}
                    />
                  </Col>
                </Row>
                <Divider />
                <Row>
                  <Col md={12} className='text-right'>
                    <RetrocederButton />
                    <Button disabled={isSubmitting} className='ml-2' onClick={handleSubmit}>
                      Guardar
                    </Button>
                  </Col>
                </Row>
              </Form>
            </>
          )}
        </Formik>
      </Col>
    </Row>
  )
}

export default NuevoMainForm
